module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "div",
      "id": "inventoryList"
    }
  }, [_c('table', {
    key: 'setupAlerts',
    staticClass: "ui very compact table",
    staticStyle: {
      "border-bottom-left-radius": "0",
      "border-bottom-right-radius": "0"
    }
  }, [_c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup FBA Inventory Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBA Inventory',
      "api-prefix": 'inventory'
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup FBM Inventory Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'FBM Inventory',
      "api-prefix": 'fbm_inventory'
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "ui accordion"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            Setup Sales Volume Alerts\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "height": "195px",
      "overflow": "hidden"
    }
  }, [_c('SpreadsheetConfig', {
    attrs: {
      "watch-dog-name": 'Sales Volume',
      "api-prefix": 'salesdrop'
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    key: 'productsStock',
    staticClass: "horizontal-scroll-container",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "ui very compact table",
    staticStyle: {
      "border-top-left-radius": "0",
      "border-top-right-radius": "0",
      "background-color": "transparent"
    }
  }, _vm._l((_vm.sortedUnfoldedProducts), function(product) {
    return ((_vm.$parent.filterByMarket.length == 0 || _vm.$parent.filterByMarket.indexOf(product.marketplace) >= 0) && (_vm.$parent.filterBySellAcc.length == 0 || _vm.$parent.filterBySellAcc.indexOf(product.sellerId) >= 0) && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId]) ? _c('tr', {
      key: product.productId,
      attrs: {
        "set": _vm.fbmItem = _vm.getFbmItem(product.productId)
      }
    }, [_c('td', {
      staticClass: "ui collapsing "
    }, [_c('i', {
      class: '' + product.marketplace.toLowerCase().replace('uk', 'gb') + ' flag'
    }), _vm._v(" "), _c('small', [_c('a', {
      attrs: {
        "href": "#",
        "qqstyle": "text-decoration:underline;"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_vm._v("\n              " + _vm._s(product.productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1")) + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "ui collapsing"
    }, [_c('img', {
      staticClass: "ui image tiny",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": product.largeImageUrl
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showProductDetails(product.productId)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: " four wide "
    }, [_c('div', {
      staticStyle: {
        "max-height": "5.5em",
        "overflow": "hidden"
      }
    }, [_vm._v("\n            " + _vm._s(product.productTitle) + "\n          ")])]), _vm._v(" "), (product.ageHours > -1) ? _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_c('div', {
      staticClass: "salesQuickInfo",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-html": '<img src=\'/api/sentinel/watchdog/salesdropchart/' + _vm.$parent.$parent.worldStore.watchDogs.salesDrop.items[product.productId].watchDogId + '\' style=\'height:200px;\'/>'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(product.salesYesterday))]), _vm._v("  units sold ystd. "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(product.salesToday))]), _vm._v("  so far today (" + _vm._s(product.marketplace) + ")\n          ")])]) : _c('td', {}, [_c('i', {
      staticClass: "dollar icon",
      staticStyle: {
        "margin-right": "1px"
      }
    }), _vm._v("\n          Sales data not avail. yet\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres') >= 0) ? _c('i', {
      staticClass: "large icons",
      attrs: {
        "data-tooltip": "No alert thresholds have been set yet. Use setup at the top."
      }
    }, [_c('i', {
      staticClass: "warehouse grey icon",
      staticStyle: {
        "opacity": ".4"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "yellow inverted corner exclamation triangle icon",
      staticStyle: {
        "opacity": ".4"
      }
    })]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 0) ? _c('i', {
      staticClass: "large green checkmark icon"
    }) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 1) ? _c('i', {}, [_c('i', {
      staticClass: "large orange exclamation triangle icon"
    })]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status == 2) ? _c('i', {}, [_c('i', {
      staticClass: "large red exclamation triangle icon"
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(product.inboundQty > 0) ? _c('div', {
      staticStyle: {
        "line-height": "1.5em"
      }
    }, [_vm._v("\n            FBA Total inv.:  "), _c('strong', [_vm._v(_vm._s(product.totalQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Available:        "), _c('strong', [_vm._v(_vm._s(product.inStockQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Inbound:     "), _c('strong', [_vm._v(_vm._s(product.inboundQty))])]) : _c('div', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n            FBA Total inv.:  "), _c('strong', [_vm._v(_vm._s(product.totalQty))]), _vm._v(" "), _c('br'), _vm._v("\n            FBA Available:        "), _c('strong', [_vm._v(_vm._s(product.inStockQty))])])]), _vm._v(" "), (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].status > 0) ? _c('td', {
      staticClass: "collapsing"
    }, [(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails && _vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.indexOf('No alert thres') === -1) ? _c('span', {
      staticStyle: {
        "color": "#b33"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace(/(\d+)/gi, '<b style=\'color:#444;\'>$1</b>').replace('; est.', '.<br>Est.'))
      }
    }) : (product.totalQty == 0) ? _c('span', {
      staticStyle: {
        "color": "#b33"
      }
    }, [_vm._v("\n          Out of Stock\n        ")]) : _vm._e()]) : (_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.match(/.*days left.*/)) ? _c('td', {
      staticClass: "collapsing"
    }, [_c('h3', {
      staticClass: "ui header"
    }, [_c('span', {
      staticStyle: {
        "color": "purple"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].statusDetails.message.replace(/.*days left: (\d*).*/, '$1')) + "\n          ")]), _vm._v(" days left\n            "), _c('div', {
      staticClass: "sub header"
    }, [_vm._v("\n              based on last\n              " + _vm._s(_vm.$parent.$parent.worldStore.watchDogs.inventory.items[product.productId].settings.velocityLookbackDays) + "d\n            ")])])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [(_vm.fbmItem === null || _vm.fbmItem.alertThreshold === null) ? _c('i', {
      staticClass: "large icons",
      attrs: {
        "data-tooltip": "No alert thresholds have been set yet. Use setup at the top."
      }
    }, [_c('i', {
      staticClass: "warehouse grey icon",
      staticStyle: {
        "opacity": ".4"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "yellow inverted corner exclamation triangle icon",
      staticStyle: {
        "opacity": ".4"
      }
    })]) : (!_vm.fbmItem.hasIssue) ? _c('i', {
      staticClass: "large green checkmark icon"
    }) : _c('i', {}, [_c('i', {
      staticClass: "large red exclamation triangle icon"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "collapsing",
      staticStyle: {
        "padding-right": "30px"
      }
    }, [(_vm.fbmItem) ? _c('div', {
      staticStyle: {
        "line-height": "1.8em"
      }
    }, [_vm._v("\n            FBM Total inv.:    "), _c('strong', [_vm._v(_vm._s(product.fbmQty ? product.fbmQty : 0))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.fbmItem.alertThreshold) ? _c('span', [_vm._v("FBM Threshold:        "), _c('strong', [_vm._v(_vm._s(_vm.fbmItem.alertThreshold))])]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-154bebca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryList.vue
// module id = 729
// module chunks = 2